import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import DebitCreditAddForm from "../../components/DebitCredit/Add/DebitCreditAddForm";

const DebitCreditAddPage = (props) => {
  return (
    <Wrapper>
      <BreadcrumbsTemp
        items={[
          {
            title: "افزودن بدهی یا طلب ",
            to: "/debit-credit/add",
          },
        ]}
      />

      <Grid container={true}>
        <Grid item xs={12}>
          <DebitCreditAddForm />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default DebitCreditAddPage;
